module.exports = __webpack_public_path__ + "img/gld_gbt100_1986.prt.8f2ae03b.jpg";